const student_strings = {
    en: {
        student: "client",
        students: "clients",
        clients_total: 'Total number of clients',
        clients_active: 'Clients with active ticket',
        edit_client: 'Edit client',
        client_info: 'Client info',
        select_client: 'Select client',
        registered_from_client_app: "This client registered to the class from the Open Client app",
        cancelled_expl: "This client registration to the class is cancelled",
        waiting_expl: "This client is on the Waiting list",
        remove_from_class: "Remove client from the class",
        search_client: "Search client",
        view_client: "Preview",
        reminder_info: "Following classes might not have been paid:",
        add_regular_client: "Add regular client",
        include_deleted: "Include deleted clients",
        recover_client: "Recover client",
        client_since: "Client since",
        clients_new: "Only new clients",
        clients_deleted: "Only deleted",
        clients_blocked: "Blocked (reached the cancellation limit)",
        merge_with: "Merge with ..",
        canc_limit_reached: "Cancellation limit is reached.",
        unblock: "Unblock",
        regular_classes: "Auto check in",
        regular_classes_expl: "Select class types which {0} will be automatically registered to.",
        groups: "group(s)",
        //currentDate: 'The current date is {month} {day}, {year}!',
        //strings.formatString(strings.question, strings.bread, strings.butter)
        // strings.formatString(strings.currentDate, {
        //  month: strings.january,
        //  day: 12,
        //  year: 2018
        // })
    },
    es: {
        student: "cliente",
        students: "clientes",
        clients_total: 'Número total de clientes',
        clients_active: 'Clientes con ticket activo',
        edit_client: 'Editar el cliente',
        client_info: 'Información de cliente',
        select_client: 'Seleccione el cliente',
        registered_from_client_app: "Este cliente se registró en la clase desde la aplicación Open Client",
        cancelled_expl: "La registración de este cliente a la clase se cancela",
        waiting_expl: "Este cliente está en la lista de espera",
        remove_from_class: "Quitar cliente de la clase",
        search_client: "Buscar cliente",
        view_client: "Vista previa",
        reminder_info: "Las clases siguientes podrían no haber sido pagadas:",
        add_regular_client: "Añadir cliente regular",
        include_deleted: "Incluir los clientes borrados",
        recover_client: "Recuperar cliente",
        client_since: "Cliente desde",
        clients_new: "Sólo los nuevos clientes",
        clients_deleted: "Sólo clientes borrados",
        clients_blocked: "Bloqueado (ha alcanzado el límite de cancelación)",
        merge_with: "Fusionar con ..",
        canc_limit_reached: "Se alcanza el límite de cancelaciones",
        unblock: "Desbloquear",
        regular_classes: "Registro automático",
        regular_classes_expl: "Seleccione los tipos de clase a los que {0} se registrará automáticamente.",
        groups: "grupo(s)",
    },
    ru: {
        student: "клиент",
        students: "клиенты",
        clients_total: 'Общее число клиентов',
        clients_active: 'Клиенты с активным абонементом',
        edit_client: 'Редактирование клиента',
        client_info: 'Информация о клиенте',
        select_client: 'Выберите клиента',
        registered_from_client_app: "Этот клиент зарегистрировался в классе из приложения OPEN Client.",
        cancelled_expl: "Регистрация данного клиента в классе отменена",
        waiting_expl: "Этот клиент находится в списке ожидания",
        remove_from_class: "Удалить клиента из класса",
        search_client: "Поиск клиентов",
        view_client: "Предварительный просмотр",
        reminder_info: "Следующие занятия, возможно, не были оплачены:",
        add_regular_client: "Добавить постоянного клиента",
        include_deleted: "Отображать удаленных клиентов",
        recover_client: "Восстановить клиента",
        client_since: "Клиент с",
        clients_new: "Только новые клиенты",
        clients_deleted: "Только удалённые",
        clients_blocked: "Заблокированные (превсысили лимит отмены резерваций)",
        merge_with: "Объединить с ..",
        canc_limit_reached: "Лимит отмен достигнут",
        unblock: "Разблокировать",
        regular_classes: "Авторегистрация",
        regular_classes_expl: "Выберите типы занятий, на которые {0} будет регистрироваться автоматически.",
        groups: "группа(ы)",
    },
};

export {student_strings};